import CommonBody from 'components/organisms/Layouts/commonBody'
import CommonSidebar from 'components/organisms/Layouts/commonSidebar'
import * as React from 'react'
import { BREAKPOINT_DESKTOP, COLORS, FOOTER_HEIGHT, HEADER_HEIGHT } from 'static/constants'
import { IUser } from 'static/interfaces'
import styled from 'styled-components'
import { getRoleLabel, isShowSidebarFromRoleLabel } from 'utils/layout'

interface IProps {
  children: React.ReactElement
  user: IUser
  showSidebar?: boolean
  className?: string
  maxContent?: boolean
}

const SidebarLayout: React.VFC<IProps> = ({
  children,
  user,
  showSidebar = false,
  className,
  maxContent = false,
}) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const childrenWithProps = React.cloneElement(children, user)

  // Post special case (only show sidebar for own posts)
  const approvedUser = (user?.guide && user?.guide_approved) || user?.agent
  const roleLabel = getRoleLabel(user)

  const isGuestUser = roleLabel === 'guest'

  return isShowSidebarFromRoleLabel(roleLabel) || showSidebar ? (
    <Base className={isGuestUser ? 'guest-user' : ''}>
      {!isGuestUser && (
        <CommonSidebar open={isOpen} roleLabel={roleLabel} approvedUser={approvedUser} />
      )}
      <CommonBody
        className={className}
        childrenWithProps={childrenWithProps}
        maxContent={maxContent}
      />
    </Base>
  ) : (
    <>{childrenWithProps}</>
  )
}
const Base = styled.div`
  width: 100%;
  display: flex;
  background: ${COLORS.background};
  min-height: calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px);
  &.guest-user {
    background: ${COLORS.white};
  }
  @media (max-width: ${BREAKPOINT_DESKTOP}px) {
    min-height: calc(100vh - ${FOOTER_HEIGHT}px);
  }
  .burgerWrapper {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2001;
    @media (max-width: ${BREAKPOINT_DESKTOP}px) {
      display: block;
    }
  }
`

export default SidebarLayout
